import { en } from './en'
import { language } from './language'
import { ru } from './ru'

export const t = language === 'ru' ? ru : en
export { language, setLanguage, storeLanguage } from './language'
export type { Language } from './language'
export { term, terms, vocabulary } from './vocabulary'
export type { VocabularyKind } from './vocabulary'
export { counted, pluralForm } from './plural'
export type { Forms } from './plural'
